<template>
  <div class="flex w-full">
    <article class="card">
      <div class="flex sm:flex-wrap md:flex-no-wrap ">
        <div class="card-hero-image">
          <img
            :src="avatarUrl"
            alt=""
            class="max-w-xs  w-24"
          >
        </div>
        <div class="card-content">
          <small v-text="'Push Notification'" />
          <h3 class="-mb-2">
            {{ name }} pushed a notification "{{ item.subject.attributes.title }}"
          </h3>
          <div
            class="mt-2 text-sm text-grey-dark"
            v-text="date"
          />
        </div>
      </div>
    </article>
  </div>
</template>

<script type="text/babel">
import ActivityItemMixin from '../../mixins/ActivityItemMixin'

export default {
  name: 'PushNotificationCreated',
  mixins: [ActivityItemMixin],
}
</script>
